import styled from 'styled-components';

export const TabsWrapper = styled.div`
  height: 100%;
  
  .ant-form-item {
    min-width: 288px;
  }
  
  .ant-tabs-nav {
    padding-left: 0 !important;
  }
  .ant-tabs-tabpane > div {
    width: 100%;
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  margin-top: 16px;
`;


export const InfoElement = styled.div`
  display: flex;
  margin-bottom: 14px;
  & > div:first-child {
    margin-right: 8px;
  }
  & > div:last-child {
    max-width: 211px;
    word-wrap: break-word;
  }
`;

export const InfoBlock = styled.div`
  margin-right: 48px;
`;
